"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBungalowLocation = function SvgBungalowLocation(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#4A4A4A",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.45 9.597a1.65 1.65 0 0 1-1.65-1.598 1.65 1.65 0 1 1-3.3 0 1.653 1.653 0 0 1-1.65 1.598c-.911 0-1.65-.053-1.65-1.65C5.2 6.882 7.398 5.233 11.794 3 16.198 5.29 18.4 6.94 18.4 7.947c0 1.511-.739 1.65-1.65 1.65a1.65 1.65 0 0 1-1.65-1.598 1.653 1.653 0 0 1-1.65 1.598z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.939 8.806c1.774 1.255 2.661 2.252 2.661 2.99 0 2.016-.985 2.2-2.2 2.2a2.2 2.2 0 0 1-2.199-2.13 2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 1 1-4.4 0 2.203 2.203 0 0 1-2.201 2.13c-1.215 0-2.2-.07-2.2-2.2 0-.762.845-1.75 2.536-2.962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13.897V20H6v-6.103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.5h3v3h-3z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBungalowLocation);
var _default = exports["default"] = Memo;